import React from 'react';
import t from 'prop-types';
import Pestana from './pestana';

var PestanaRetroceso = function PestanaRetroceso(_ref) {
  var boton = _ref.boton,
      onBoton = _ref.onBoton;
  var clases = ['previoNavegarVentana'];

  if (boton.anulado) {
    clases.push('desactivado');
  }

  return React.createElement(Pestana, {
    boton: boton,
    onBoton: onBoton,
    clases: clases
  });
};

PestanaRetroceso.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object,
  onBoton: t.func
} : {};
export default PestanaRetroceso;